import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { useEffect, useState } from 'react';
import BarCode from "react-barcode";
import { useLocation, useNavigate } from 'react-router-dom';
import Header from '../../Components-2/Header/Header';
import Sidebar1 from '../../Components-2/Sidebar1';

function NewDP3() {
    const [getBranch, setGetBranch] = useState([]);
    const [loading, setLoading] = useState(true);
    const [total, setTotal] = useState(0);
    const navigate = useNavigate();
    const location = useLocation();
    console.log(location);
    console.log(location.state);
    const fromPath = location?.state?.path || "/";
    const tab = location?.state?.tab;
    const res = location?.state?.data;
    const [data, setData] = useState([]);
    useEffect(() => {
        setData(res?.Data || []);
        setGetBranch(res?.BranchDetails[0] || {});
    }, [])


    const formateDate = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        if (isNaN(date)) return ""; // invalid date
        return date.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric"
        });
    };


    const handleDownloadPDF = async () => {
        await document.fonts.ready;

        const docketElements = document.querySelectorAll(".docket");
        if (!docketElements.length) return;

        const pdf = new jsPDF("p", "mm", "a4");

        const pxToMm = 25.4 / 96;

        for (let i = 0; i < docketElements.length; i++) {
            const element = docketElements[i];

            const canvas = await html2canvas(element, {
                scale: 4,
                useCORS: true,
                backgroundColor: "#fff",
            });

            const imgData = canvas.toDataURL("image/jpeg", 1.0);

            const renderWidth = element.offsetWidth * pxToMm;
            const renderHeight = element.offsetHeight * pxToMm;

            const x = 10;
            const y = 10;

            pdf.addImage(
                imgData,
                "JPEG",
                x,
                y,
                renderWidth,
                renderHeight,
                undefined,
                "FAST"
            );

            if (i < docketElements.length - 1) {
                pdf.addPage();
            }
        }

        pdf.save("NewDp3.pdf");
    };


    const chunkSize = 4;

    const docketGroups = [];

    for (let i = 0; i < data.length; i += chunkSize) {
        docketGroups.push(data.slice(i, i + chunkSize));
    }







    return (
        <>
            <style>{`
           @media print {

  @page {
    size: A4 portrait;
    margin: 8mm;
  }

  html,
  body {
    margin: 0 !important;
    padding: 0 !important;
  }

  body * {
    visibility: hidden;
  }

  #pdf,
  #pdf * {
    visibility: visible;
  }

  #pdf {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    margin: 0 !important;
    padding: 0 !important;
    border: none !important;
  }

  .docket {
    width: 190mm;
    min-height: 279mm;
    margin: 0 auto !important;
    padding: 5mm;
    box-sizing: border-box;

    page-break-after: always;
    page-break-inside: avoid;
    break-after: page;
    break-inside: avoid;
  }

  .docket:last-child {
    page-break-after: auto;
  }
}
`}</style>





            <Header />
            <Sidebar1 />

            {data?.length > 0 && (
                <div id="main-body">
                    <div className="container py-0">
                        <div className="container-2 py-1" style={{ borderRadius: "0px", width: "760px", gap: "5px", border: "none" }}>
                            <div className="container-2" style={{ borderRadius: "0px", width: "760px", display: "flex", flexDirection: "row", border: "none", justifyContent: "end", gap: "10px", fontSize: "12px" }}>
                                <button
                                    onClick={handleDownloadPDF}
                                    style={{ padding: "5px 5px", borderRadius: "6px", background: "green", color: "white", border: "none", cursor: "pointer" }}
                                >
                                    Download
                                </button>
                                <button
                                    onClick={() => window.print()}
                                    style={{ padding: "5px 10px", borderRadius: "6px", background: "red", color: "white", border: "none", cursor: "pointer" }}
                                >
                                    Print
                                </button>
                                <button
                                    onClick={() => navigate(fromPath, { state: { tab: tab } })}
                                    style={{ padding: "5px 10px", borderRadius: "6px", background: "gray", color: "white", border: "none", cursor: "pointer" }}
                                >
                                    Exit
                                </button>
                            </div>
                        </div>
                        <div id='pdf' style={{ borderRadius: "0px", border: "1px solid black", paddingLeft: "20px", fontFamily: '"Times New Roman", Times, serif', paddingRight: "20px", paddingTop: "20px", paddingBottom: "20px", display: "flex", flexDirection: "column", alignItems: "center", gap: "5px" }}>
                            {docketGroups.map((group, pageIndex) => (
                                <div
                                    key={pageIndex}
                                    className="docket"
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "30px",
                                        width: "190mm",
                                        minHeight: "277mm",
                                        margin: "0px auto",
                                        boxSizing: "border-box",
                                        marginBottom: "30px",


                                    }}
                                >
                                    {group.map((docket, index) => (
                                        <div
                                            key={index}
                                            className="section"
                                            style={{
                                                border: "1px solid gray",
                                                padding: "10px",
                                                borderRadius: "0px",
                                                display: "flex",
                                                flexDirection: "column",
                                                fontSize: "12px",

                                            }}
                                        >
                                            <div className='div1' style={{ width: "100%", color: "black", display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                <div style={{ fontSize: "20px", fontWeight: "bold" }}>{getBranch?.Company_Name}</div>

                                                <div style={{ display: "flex", gap: "20px", justifyContent: "center" }}>
                                                    <div><b>GST No :</b> {getBranch?.GSTNo}</div>
                                                    <div><b>Website :</b> {getBranch?.Website}</div>
                                                    <div><b>Mob:</b> (+91) {getBranch?.MobileNo}</div>
                                                </div>


                                            </div>
                                            <div className='div2' style={{ width: "100%", color: "black", display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                <div style={{ fontSize: "24px", fontWeight: "bold" }}>
                                                    Awb No
                                                </div>
                                                <BarCode
                                                    value={docket?.DocketNo}
                                                    format='CODE128'
                                                    background='#fff'
                                                    lineColor='#000'
                                                    width={1.5}
                                                    height={40}
                                                    displayValue={true}
                                                />

                                            </div>
                                            <div className='div3' style={{ width: "100%", color: "black", display: "flex", justifyContent: "space-around", gap: "100px" }}>
                                                <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>


                                                    <div> <b>Book Date :</b>  {docket?.BookDate}</div>
                                                    <div>Master ID : {docket?.VendorAwbNo}</div>
                                                    <div style={{ fontWeight: "bold", fontSize: "12px" }}>
                                                        {docket?.Consignee_Name}</div>
                                                    <div>

                                                        {docket?.Consignee_Add1},{docket?.Consignee_Add2},{docket?.Consignee_State}-{docket?.DestPinCode}
                                                    </div>
                                                    <div style={{ fontWeight: "bold", fontSize: "12px" }}>
                                                        {docket?.Customer_Name}
                                                    </div>


                                                </div>


                                                <div style={{ display: "flex", flexDirection: "column", fontWeight: "bold", fontSize: "12px", width: "250px" }}>
                                                    <div >
                                                        Received By:_______________________
                                                    </div>
                                                    <div >
                                                        Relation:__________________________
                                                    </div>
                                                    <div >
                                                        Contact No:________________________
                                                    </div>
                                                    <div style={{ display: "flex", gap: "5px" }}>
                                                        <span>Date:_______________</span>
                                                        <span>Sign:</span>
                                                    </div>



                                                </div>




                                            </div>


                                        </div>))}










                                </div>
                            ))
                            }

                        </div>
                    </div>
                </div>
            )

            }
        </>
    )
}

export default NewDP3;